import React, { FC, useContext } from 'react';

import { SettingsBlock, SettingsFrame } from 'components';
import { LocalizationContext } from 'localization';

import { Currency, LanguageControl } from './components';

export const Vote: FC = () => {
  const { t } = useContext(LocalizationContext);

  return (
    <>
      <SettingsBlock title={t('vote')}>
        <SettingsFrame>
          <Currency />
        </SettingsFrame>

        <LanguageControl />
      </SettingsBlock>
    </>
  );
};
